import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { GreenworksService } from '../greenworks.service';

const ERROR_LOGGING_INTO_STEAM_ACCOUNT = 
'An error occurred while logging into your Steam account. Please restart Steam and try again.';

@Injectable()
export class CommunityServersService {
    _authSessionTicket = null;

    _dataSbj: BehaviorSubject<IServer[]> = new BehaviorSubject([]);
    data$: Observable<IServer[]> = this._dataSbj.asObservable();

    constructor(
        private _greenworksSrv: GreenworksService
    ) {
        new Promise(async (resolve) => {
            // TODO: It's hack to output servers list after end logo animation
            await new Promise((resolve) => setTimeout(resolve, 500));

            this._greenworksSrv.getAuthSessionTicket()
                .then((authSessionTicket) => this._authSessionTicket = authSessionTicket)
                .catch(() => {})
                .then(() => this.getServers())
                .then((servers) => this._dataSbj.next(servers));

            resolve(null);
        });
    }

    async getServers(): Promise<IServer[]> {
        let servers = [];
        let likes = [];

        try {
            const response = await fetch(`${ window.CONFIG.API_URL }servers/list`, {
                method: 'POST',
                headers: { 'content-type': 'application/json;charset=UTF-8' },
                body: JSON.stringify({ steamTicket: this._authSessionTicket })
            });

            ({ servers, likes } = await response.json());

            likes = likes.reduce((acc, like) => {
                acc[like.server] = like;
                return acc;
            }, {});

            servers = servers.map((server) => ({
                ...server,

                apiUrl: `${ getUrl(server) }/api/`,
                websocketUrl: `${ getUrl(server) }/socket/`,
                prefix: 'local',

                status: null,
                likeCount: server.likeCount || 0,
                isLiked: !!likes[server._id]
            }));
        } catch (err) {
            // Noop.
        }

        return servers;
    }

    async likeServer(server) {
        if (!this._authSessionTicket) {
            throw ERROR_LOGGING_INTO_STEAM_ACCOUNT;
        }

        this.patch(server, {
            isLiked: true,
            likeCount: server.likeCount + 1
        });

        try {
            await fetch(`${ window.CONFIG.API_URL }servers/like`, {
                method: 'POST',
                headers: { 'content-type': 'application/json;charset=UTF-8' },
                body: JSON.stringify({
                    server: server._id,
                    steamTicket: this._authSessionTicket
                })
            });
        } catch (err) {
            // TODO: Need to show toastr with error;
            this.patch(server, {
                isLiked: false,
                likeCount: server.likeCount
            });
        }
    }

    async unlikeServer(server) {
        if (!this._authSessionTicket) {
            throw ERROR_LOGGING_INTO_STEAM_ACCOUNT;
        }

        this.patch(server, {
            isLiked: false,
            likeCount: server.likeCount - 1
        });

        try {
            await fetch(`${ window.CONFIG.API_URL }servers/unlike`, {
                method: 'POST',
                headers: { 'content-type': 'application/json;charset=UTF-8' },
                body: JSON.stringify({
                    server: server._id,
                    steamTicket: this._authSessionTicket
                })
            });
        } catch (err) {
            // TODO: Need to show toastr with error;
            this.patch(server, {
                isLiked: true,
                likeCount: server.likeCount
            });
        }
    }

    patch(server: IServer, data: any) {
        const servers = this._dataSbj.getValue();
        const idx = servers.findIndex(({ _id }) => _id === server._id);
        const _servers = [...servers];
        _servers.splice(idx, 1, {
            ...server,
            ...data
        });

        this._dataSbj.next(_servers);
    }
}

function getUrl(server: IServer) {
    const { host, port } = server.settings;

    return `http://${ host }${ port ? (':' + port) : '' }`;
}
